import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useDeleteDrugQuote = () => {
    const { mutate: deleteDrugQuote, isLoading } = useMutation(
        async (id) => {
            const response = await SrxApi.delete(`/drugsearch/deletequote/${id}`);
            return response?.data;
        },
        {
            onSuccess: (data) => {
                const message =
                    data?.message ?? data?.data?.message ?? 'Drug quote deleted successfully!';
                toast.success(message);
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message || error?.message || 'Failed to delete drug quote';
                toast.error(errorMessage);
            },
        }
    );

    return {
        deleteDrugQuote,
        isDeleteDrugQuoteLoading: isLoading,
    };
};

export default useDeleteDrugQuote;
